import { type PropertyID, SystemProperties } from "@ext/properties/models";

export const HIERARCHY_GROUPING: PropertyID[] = [SystemProperties.hierarchy];

export const resolveGroupBy = (groupBy?: PropertyID[]): PropertyID[] => {
	const selected = groupBy?.filter((id) => id !== SystemProperties.hierarchy) ?? [];
	return selected.length ? selected : HIERARCHY_GROUPING;
};

export const isHierarchyGrouping = (groupBy: PropertyID[]): boolean =>
	groupBy.length === 1 && groupBy[0] === SystemProperties.hierarchy;
